
import { defineComponent, PropType } from 'vue'

import VideoDetailsQuestionForm from '@/components/VideoDetailsQuestionForm.vue'
import VideoDetailsQuestionMessages from '@/components/VideoDetailsQuestionMessages.vue'
import { VideoQuestionAttributes } from '@/types/models/video-question'
import BaseAlert from '@/components/BaseAlert.vue'

export default defineComponent({
  props: {
    videoQuestions: {
      type: Array as PropType<VideoQuestionAttributes[] | undefined>,
      'default': () => ([]),
    }
  },
  components: { VideoDetailsQuestionForm, VideoDetailsQuestionMessages, BaseAlert },
})
